import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Vtc} from '../../../forms/modules/vtc/models/vtc';

@Pipe({
  name: 'filterSearchVtc'
})
export class FilterSearchVtcPipe implements PipeTransform {

  constructor(private cdr: ChangeDetectorRef, private translate: TranslateService) {
  }

  transform(items: Vtc[], searchText: string, vtcFilterMetadata): Vtc[] {
    if (!items) {
      vtcFilterMetadata.count = 0;
      this.cdr.detectChanges();
      return [];
    }
    if (!searchText) {
      vtcFilterMetadata.count = items.length;
      this.cdr.detectChanges();
      return items;
    }
    searchText = searchText.toLowerCase();

    const filteredItems = items.filter((vtc: Vtc) => {
      const text = vtc.detail.substr(0, 50) + '...' + ' ' + vtc.year + ', ' +
        this.translate.instant('dashboard.vtc_list.subtitle.study_field') + ':' + vtc.studyField + ',' + vtc.category;
      return text.toLowerCase().indexOf(searchText) !== -1;
    });
    vtcFilterMetadata.count = filteredItems.length;
    this.cdr.detectChanges();
    return filteredItems;
  }

}
